import { LoadingHU } from 'components/LoadingHU';
import { usePrivacyContext } from 'contexts/PrivacyContext';
import React, { useState } from 'react';
import { NewConsentModal } from './components/NewConsentModal';
import { RemoveConsentModal } from './components/RemoveConsentModal';
import { RenewConsentModal } from './components/RenewConsentModal';
import { SearchArea } from './components/SearchArea';
import { SharingModal } from './components/SharingModal/SharingModal';
import { TabArea } from './components/TabArea';
import { useNewConsentModalContext } from './Context/NewConsentModalContext';
import { useRemoveConsentModalContext } from './Context/RemoveConsentModalContext';
import { useRenewConsentModalContext } from './Context/RenewConsentModalContext';
import { useTabAreaContext } from './Context/TabAreaContext';

import './SharePage.css';

export function SharePage() {
  const [searchFilter, setSearchFilter] = useState('');
  const { removeConsentModalState } = useRemoveConsentModalContext();
  const { newConsentModalState } = useNewConsentModalContext();
  const { renewConsentModalState } = useRenewConsentModalContext();
  const { loading } = useTabAreaContext();
  const { isSharing, privacyLoading } = usePrivacyContext();

  return (
    <>
      {loading || !isSharing === null || privacyLoading
        ? <LoadingHU state />
        : <SharingModal />}

      { removeConsentModalState.isOpen
       && (
         <>
           <RemoveConsentModal />
         </>
       )}
      { newConsentModalState.isOpen
       && (
         <>
           <NewConsentModal />
         </>
       )}
      { renewConsentModalState.isOpen
       && (
        <>
          <RenewConsentModal />
        </>
       )}

      <SearchArea setSearchFilter={setSearchFilter} />

      <TabArea searchFilter={searchFilter} />
    </>
  );
}
